import { AbstractRequestModel } from './Request'
import { SearchResult } from '@/models/Repository'
import MenuApi from '@/api/Menu'
import MenuRequestApi from '@/api/MenuRequest'

export class MenuRequestModel extends AbstractRequestModel {
  constructor(params) {
    super(params)
    const {
      id,
      name,
      description,
      menuType,
      resourceType,
      resourceId,
      resourceName,
      requestAccountId,
      requestAccountName,
      requestStatus,
      requestTime,
      requestType,
      unitType,
      unitPrice,
      currency,
      startDate,
      endDate,
    } = params

    this.id = id
    this.name = name
    this.description = description
    this.menuType = menuType
    this.resourceType = resourceType
    this.resourceId = resourceId
    this.resourceName = resourceName
    this.requestAccountId = requestAccountId
    this.requestAccountName = requestAccountName
    this.requestStatus = requestStatus
    this.requestTime = requestTime
    this.requestType = requestType
    this.unitType = unitType
    this.unitPrice = unitPrice
    this.currency = currency
    this.startDate = startDate
    this.endDate = endDate

    this.menu = null
  }
  async getMenu() {
    if (!this.id) return null
    const result = await MenuApi.search({ id: this.id })
    return result.items.length > 0 ? result.items[0] : null
  }
  async fetchMenu() {
    if (!this.id) return
    this.menu = await this.getMenu()
  }
  async approve() {
    const requestStatus = 'approved'
    return await MenuRequestApi.update(this.id, { requestStatus })
  }

  async reject(reason) {
    const requestStatus = 'rejected'
    return await MenuRequestApi.update(this.id, { requestStatus, reason })
  }
}

export class MenuRequestRepository {
  static async search({
    systemOwnerId,
    requestStatus,
    keyword,
    pageSize,
    pageNo,
    sortBy,
    descending,
  } = {}) {
    const query = {
      systemOwnerId,
      keyword,
      requestStatus:
        requestStatus === 'all'
          ? ['approved', 'rejected', 'waiting']
          : requestStatus,
    }
    const result = await MenuApi.searchRequest(query, pageSize, pageNo)
    const items = result.items
      .map(item => new MenuRequestModel(item))
      .sort((a, b) => {
        if (a[sortBy] > b[sortBy]) {
          return descending ? 1 : -1
        } else if (a[sortBy] < b[sortBy]) {
          return descending ? -1 : 1
        }
        return 0
      })
    return new SearchResult({
      count: result.count,
      pageNo: result.pageNo,
      pageSize,
      items,
    })
  }

  static async bulkApprove(ids) {
    // TODO: bulk_approve を使う
    console.log(ids)
    return Promise.resolve(ids.length > 0)
  }

  static async cancelRequest(id) {
    try {
      await MenuRequestApi.delete(id)
    } catch (e) {
      console.error(e)
      throw new Error('申請を取り消せませんでした')
    }
  }
}
